"use client";

import { useMemo } from "react";
import { useQuoteTheme } from "./use-quote-theme";
import { quoteThemeColorStyles, quoteThemeCssVars } from "./quote-theme-css-vars";
import { usePrimaryColorStyles } from "../contexts/use-primary-color-styles";

export function useQuoteThemeStyles() {
  const theme = useQuoteTheme();
  const { containerStyle, textIconStyle } = usePrimaryColorStyles();

  return useMemo(
    () => ({
      ...theme,
      vars: quoteThemeCssVars,
      colors: quoteThemeColorStyles,
      containerStyle,
      textIconStyle,
      sectionSurfaceClassName: theme.classNames.card,
      sectionHeadingClassName: theme.classNames.sectionHeading,
      sectionWrapperClassName: theme.classNames.section,
    }),
    [theme, containerStyle, textIconStyle]
  );
}

export function getFlightItineraryLayoutFromTheme(
  layoutConfig: "CONFIG_A" | "CONFIG_B" | "CONFIG_C"
): "layout_1" | "layout_2" {
  return layoutConfig === "CONFIG_C" ? "layout_1" : "layout_2";
}
